'use strict';

import store from 'client/store';

import member from './member.js'
import sessionLib from './session.js'

import clone from 'lodash/clone'
import cloneDeep from 'lodash/cloneDeep'
import filter from "lodash/filter";
import find from "lodash/find";
import forEach from "lodash/forEach";
import includes from "lodash/includes";
import map from "lodash/map";
import uniq from "lodash/uniq"

import Vue from 'vue';

export default {
  getSet: function(session, categoryId, exerciseTypeId) {
    let set = 1

    const rotationType = sessionLib.getSessionRotationType(session.id)
    const sessionCategory = find(session.categories, i => i.categoryId === categoryId)

    switch (rotationType) {
      case 'mixed': {
        const sessionCategoryExercise = find(sessionCategory.exercises, i => i.exerciseTypeId === exerciseTypeId)
        set = sessionCategoryExercise.set
        break
      }
      default:
        set = sessionCategory.set
    }

    return set
  },

  getPanel: function(session, categoryId, exerciseTypeId) {
    const set = this.getSet(session, categoryId, exerciseTypeId)
    const rotationType = sessionLib.getSessionRotationType(session.id)
    const sessionPanels = filter(store.state.panels.items, i => i.sessionId === session.id)

    return find(sessionPanels,
        i => i.set === set && (rotationType !== 'rotation' || i.exerciseTypeId === exerciseTypeId))
  },

  panelName: function(panel, type = 'full') {
    const rotationType = sessionLib.getSessionRotationType(panel.sessionId)

    let name = Vue.i18n.t('panel') + ' ';
    if (rotationType === 'rotation') {
      name += (panel.index + 1);
    } else {
      name += panel.set;
    }

    if (type === 'full' && panel.exerciseTypeId) {
      name += ' ' + Vue.i18n.t('exercise.type.' + panel.exerciseTypeId);
    }

    return name;
  },

  calculatePasses: function(panel, settings) {
    let passes = settings.passes

    if (settings.rotationType !== 'mixed' && panel.activeExerciseTypeId !== null) {
      passes = filter(passes, (pass) => pass.exerciseTypeId === panel.activeExerciseTypeId );
    }

    return passes;
  },

  calculatePositions: function(panel, panelType = null) {
    if (! panelType) {
      panelType = store.state.eventDiscipline.panelTypes.find(pt => pt.id === panel.panelTypeId)
    }

    let position = 0;
    let positions = [];
    const discipline = store.state.eventDiscipline.discipline

    forEach(panelType.groups, group => {
      let key = group.key;
      let offset = 0;
      if (group.main) {
        key = group.main.key;
        offset = group.main.offset;
      }

      for (let i = 0; i < group.size; i++) {
        const member = find(panel.members, item => includes(item.positions, position))

        const index = offset + i + 1
        const figCode = group.figCode ? group.figCode : group.key.substring(0, 1).toUpperCase()
        const groupTKey = 'score.' + group.key + '.' + discipline.code
        let groupName = Vue.i18n.t(groupTKey)
        if (groupName === groupTKey) {
          groupName = Vue.i18n.t('score.' + group.key)
        }

        positions.push({
          position,
          key,
          figCode,
          figName: figCode + (group.size > 1 ? ' ' + index : ''),
          jep: clone(group.jep),
          name: Vue.i18n.t('score.' + key) + (group.size > 1 ? ' ' + index : ''),
          group,
          groupName,
          index,
          subIndex: i + 1,
          member,
          valueTypes: group.valueTypes,
        });
        position++;
      }
    });
    return positions;
  },

  getCalculationType: function(panelType, exerciseConfig) {
    const paramType = exerciseConfig.calculationType;
    return find(panelType.calculationTypes, function(calculationType) {
      return calculationType.name === paramType;
    });
  },

  /**
   * Return the scoregroups of a paneltype for a given exercise configuration.
   * Take into account the calculation type, format and category options.
   */
  getScoreGroups: function(panelType, exerciseConfig) {
    const calculationType = this.getCalculationType(panelType, exerciseConfig)

    let scoreGroups = []

    forEach(calculationType.scoreGroups, sg => {
      if (sg.optional) {
        const value = exerciseConfig[sg.optional.option] || 0
        // skip if the score group is not applicable.
        if (sg.optional.value !== value) return
      }

      const scoreGroup = cloneDeep(sg)
      let dropped = false
      scoreGroup.elements = scoreGroup.elements.filter(e => {
        if (e.optional) {
          const value = exerciseConfig[e.optional.option] || 0
          dropped = dropped || e.optional.value !== value
          return e.optional.value === value
        }
        return true
      })

      if (scoreGroup.elements.length || !dropped) scoreGroups.push(scoreGroup)
    })

    return scoreGroups
  },

  getGroupJudgePositions: function(groupKey, panelType) {
    let positions = [];
    let offset = 0;
    forEach(panelType.groups, function (group) {
      if (includes(group.valueTypes, groupKey)) {
        for (let i = 0; i < group.size; i++) {
          positions.push(offset + i);
        }
      }
      offset += group.size;
    });
    return positions;
  },

  _scoreFieldWidth: function(maximum, precision) {
    let size = 0
    if (precision) {
      size = precision + 0.5
    }
    size += Math.floor(maximum).toString().length

    console.log(maximum, precision, size)

    if (size <= 3.5) {
      return 'u-50px'
    }
    else if (size <= '5.5') {
      return 'u-60px'
    }
    else {
      return 'u-80px'
    }
  },

  /**
   * Get a list of score fields for printed report.
   * For each field list label + query parameters to select value from scores.
   *
   * @param panelType
   * @param config
   * @returns {*[]}
   */
  getPanelFields: function(panelType, config, level) {
    console.log('get panel fields', panelType.id, config, level)
    const calculationType = this.getCalculationType(panelType, config)
    let fields = []

    forEach(calculationType.scoreGroups, scoreGroup => {
      const positions = this.getGroupJudgePositions(scoreGroup.key, panelType)

      forEach(scoreGroup.elements, element => {
        if (element.print >= level) {
          forEach(positions, (position, p_index) => {
            let label = element.key.substring(0,1).toUpperCase()
            if (level <= 1) {
              label += (p_index+1)
            }
            fields.push({
              label,
              width: this._scoreFieldWidth(element.valueType.max, element.valueType.precision),
              precision: element.valueType.precision,
              properties: {
                leg: 0,
                group: scoreGroup.key,
                element: element.key,
                position,
                index: 0,
              }
            })
          })
        }

        if (element.elementTotal.enabled && element.elementTotal.print >= level) {
          fields.push({
            label: element.key === 'total' ? Vue.i18n.t('total') : element.key.substring(0,1).toUpperCase(),
            width: this._scoreFieldWidth(element.elementTotal.valueType.max, element.elementTotal.valueType.precision),
            precision: element.elementTotal.valueType.precision,
            properties: {
              leg: 0,
              group: scoreGroup.key,
              element: element.key,
              position: -1,
              index: 0,
            }
          })
        }
      })

      if (scoreGroup.judgeTotal.enabled && scoreGroup.judgeTotal.print >= level) {
        forEach(positions, (position, p_index) => {
          fields.push({
            label: scoreGroup.key.substring(0,1).toUpperCase() + (p_index+1),
            width: this._scoreFieldWidth(scoreGroup.judgeTotal.valueType.max, scoreGroup.judgeTotal.valueType.precision),
            precision: scoreGroup.judgeTotal.valueType.precision,
            properties: {
              leg: 0,
              group: scoreGroup.key,
              element: 'total',
              position,
              index: -1,
            }
          })
        })
      }

      // add element totals and group total
      if (scoreGroup.total.enabled && scoreGroup.total.print >= level) {
        const label = scoreGroup.shortName ? scoreGroup.shortName : scoreGroup.key === 'total' ? Vue.i18n.t('total') :  scoreGroup.key.substring(0,1).toUpperCase()
        fields.push({
          label,
          width: this._scoreFieldWidth(scoreGroup.total.valueType.max, scoreGroup.total.valueType.precision),
          precision: scoreGroup.total.valueType.precision,
          properties: {
            leg: 0,
            group: scoreGroup.key,
            element: 'total',
            position: -1,
            index: -1,
          }
        })
      }
    })

    return fields
  },

  calculateCsvFields: function(exerciseTypeId, config, panelType, pass) {
    const calculationType = this.getCalculationType(panelType, config);
    let fields = [];
    const valueBase = pass + '.';

    forEach(calculationType.scoreGroups, scoreGroup => {
      const positions = this.getGroupJudgePositions(scoreGroup.key, panelType);

      // add values entered by the judges and judge total (related to judge position)
      forEach(positions, (position, p_index) => {
        forEach(scoreGroup.elements, element => {
          const label = Vue.i18n.t('score.' + element.key) + ' ';

          for (let c = 0; c < element.count; c++) {
            const countLabel = element.count > 1 ? ' ' + (c + 1) : '';
            fields.push({
              label: label + (element.valueType.enterDeduction ? ' (ded)' : '') + ' ' + (p_index + 1) + countLabel,
              value: valueBase + scoreGroup.key.replace('.', '_') +
                '.' + element.key.replace('.', '_') + '.' + position + '.' + c,
            });
          }
        });
        if (scoreGroup.judgeTotal.enabled) {
          fields.push({
            label: Vue.i18n.t('score.' + scoreGroup.key) + ' ' + (p_index + 1),
            value: valueBase + scoreGroup.key.replace('.', '_') + '.total.' + position + '.-1',
          });
        }
      });

      // add element totals and group total
      forEach(scoreGroup.elements, element => {
        const label = Vue.i18n.t('score.' + element.key) + ' ';

        if (element.elementTotal.enabled) {
          for (let c = 0; c < element.count; c++) {
            const countLabel = element.count > 1 ? ' ' + (c + 1) : '';
            fields.push({
              label: label + (element.valueType.enterDeduction ? ' (ded)' : '') + ' ' + countLabel,
              value: valueBase + scoreGroup.key.replace('.', '_') +
                '.' + element.key.replace('.', '_') + '.-1' + '.' + c,
            });
          }
        }
      });
      if (scoreGroup.total.enabled) {
        fields.push({
          label: Vue.i18n.t('score.' + scoreGroup.key) + ' total',
          value: valueBase + scoreGroup.key.replace('.', '_') + '.total.-1.-1',
        });
      }
    });

    return fields;
  },

  getPanelTask: function(panel) {
    const rotationType = sessionLib.getSessionRotationType(panel.sessionId)

    let task = ''

    switch (rotationType) {
      case 'mixed': {
        const session = store.state.sessions.items.find(s => s.id === panel.sessionId)
        let exerciseTypes = []
        session.categories.forEach(sc => {
          sc.exercises.forEach(sce => {
            if (sce.set === panel.set) {
              exerciseTypes.push(Vue.i18n.t('exercise.type.' + sce.exerciseTypeId))
            }
          })
        })
        exerciseTypes = uniq(exerciseTypes)
        task = exerciseTypes.join(', ')
        break
      }
      case 'rotation':
        task = Vue.i18n.t('exercise.type.' + panel.exerciseTypeId)
        break
    }

    return task
  },

  exportPanel: function(panel) {
    const eventDiscipline = store.state.eventDisciplines.items.find(ed => ed.id === panel.eventDisciplineId)
    const judgeRepresentation = eventDiscipline.judgeRepresentation
    const panelType = find(store.state.eventDiscipline.panelTypes, i => i.id === panel.panelTypeId)
    const positions = filter(this.calculatePositions(panel, panelType), i => i.member !== undefined)

    const positionData = map(positions, position => {
      const judge = position.member ? find(store.state.members.items, i => i.id === position.member.judgeId) : null

      let clubName = ''
      let countryId = null
      let club = null
      switch (judgeRepresentation) {
        case 'club': {
          club = position.member ? find(store.state.clubs.items, i => i.id === position.member.clubId) : null
          clubName = club.name
          countryId = club.countryId
          break
        }
        case 'country': {
          countryId = judge.countryId
          clubName = countryId ? Vue.i18n.t(countryId) : ''
          break
        }
      }


      return {
        id: judge.id,
        position: position.name,
        positionNr: position.position,
        type: position.group.key,
        figCode: position.figCode,
        jep: position.jep,
        index: position.index,
        subIndex: position.subIndex,
        judgeId: judge ? judge.accessId : null,
        judge: judge ? member.getName(judge) : null,
        judgeLastName: judge ? judge.lastName : null,
        judgeFirstName: judge ? judge.firstname : null,
        club: clubName,
        noc: countryId?.substring(8, 11).toLowerCase(),
        clubId: club ? club.accessId : null,
      };
    });

    return {
      set: panel.set,
      task: this.getPanelTask(panel),
      panel: this.panelName(panel),
      positions: positionData,
    };
  },
};
